import * as type from "../types/reset-password";

const initialState = {
  validateResetCodeStatus: null,
  validateResetCodeLoading: false,
  validateResetCodeError: null,
};

export const resetPassword = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_RESET_CODE_VALIDATION:
      return {
        ...state,
        validateResetCodeStatus: null,
        validateResetCodeLoading: true,
        validateResetCodeError: null,
      };
    case type.REVOKE_RESET_CODE_VALIDATION:
      return {
        ...state,
        validateResetCodeStatus: null,
        validateResetCodeLoading: false,
        validateResetCodeError: payload.message,
      };
    case type.GRANT_RESET_CODE_VALIDATION:
      return {
        ...state,
        validateResetCodeStatus: "success",
        validateResetCodeLoading: false,
        validateResetCodeError: null,
      };
    case type.RESET_RESET_CODE_VALIDATION:
      return {
        ...state,
        validateResetCodeStatus: null,
        validateResetCodeLoading: false,
        validateResetCodeError: null,
      };
    default:
      return state;
  }
};
